import { render, staticRenderFns } from "./HomeBody.vue?vue&type=template&id=67389dd9&scoped=true&"
import script from "./HomeBody.vue?vue&type=script&lang=js&"
export * from "./HomeBody.vue?vue&type=script&lang=js&"
import style0 from "./HomeBody.vue?vue&type=style&index=0&id=67389dd9&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67389dd9",
  null
  
)

export default component.exports